<template>
    <div v-if="value" class="drawMultiFailResultModal">
        <ResultModal v-model="value" v-bind="drawResult" @close="close" @btn-click="handleBtnClick">
            <template #cover>
                <PrizeList :list="drawResult.coverList" />
            </template>
        </ResultModal>
    </div>
</template>

<script>
import ResultModal from '../ResultModal/index.vue';
import PrizeList from '../PrizeList/index.vue';

export default {
    name: 'multiDrawFailResultModal',
    components: {
        ResultModal,
        PrizeList
    },
    props: {
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        drawResult: {
            type: Object,
            // eslint-disable-next-line no-empty-function
            default: () => {}
        }
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        handleBtnClick() {
            this.$emit('modal-btn-click');
        }
    }
};
</script>

<style lang="less" scoped>
.drawMultiFailResultModal {
    /deep/.resultModal .wrapper .title {
        margin-bottom: 10px;
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        color: #fff;
        font-family: 'brSemiBold';
        &::before,
        &::after {
            display: none;
        }
    }
    /deep/.resultModal .wrapper .desc {
        margin-bottom: 18px;
        line-height: 1.2;
        text-align: center;
        font-size: 18px;
        color: #fff;
        .highlight {
            color: #ff6900;
        }
    }

    .close {
        position: absolute;
        display: block;
        width: 24px;
        height: 24px;
        background-image: url('./images/close.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        bottom: -28px;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
